// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_components__CopyButton from "../../../../../../../packages/components/src/CopyButton.js";
import * as Buhta_landing__ClassifierModel from "../ClassifierModel.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../../../packages/util/lib/Formating.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import ReactInfiniteScrollComponent from "react-infinite-scroll-component";
import * as JsxRuntime from "react/jsx-runtime";

function KogdListView(Props) {
  let ogds = Props.ogds;
  const match = React.useState(function () {
    return /* [] */ 0;
  });
  const setDisplayData = match[1];
  const displayData = match[0];
  const match$1 = React.useState(function () {
    return true;
  });
  const setHasMore = match$1[1];
  const page = React.useRef(1);
  React.useEffect((function () {
    if (20 >= Buhta_landing__ClassifierModel.ogdLength(ogds)) {
      Curry._1(setDisplayData, (function (param) {
        return ogds;
      }));
    } else {
      Curry._1(setDisplayData, (function (param) {
        return Buhta_landing__ClassifierModel.takeOgds(ogds, 20);
      }));
    }
    page.current = 1;
    Curry._1(setHasMore, (function (param) {
      return true;
    }));
  }), [ogds]);
  const loadMore = function (param) {
    if (Buhta_landing__ClassifierModel.ogdLength(displayData) >= Buhta_landing__ClassifierModel.ogdLength(ogds)) {
      Curry._1(setHasMore, (function (param) {
        return false;
      }));
    }
    page.current = page.current + 1 | 0;
    if (Math.imul(20, page.current) >= Buhta_landing__ClassifierModel.ogdLength(ogds)) {
      return Curry._1(setDisplayData, (function (param) {
        return ogds;
      }));
    } else {
      return Curry._1(setDisplayData, (function (param) {
        return Buhta_landing__ClassifierModel.takeOgds(ogds, Math.imul(20, page.current));
      }));
    }
  };
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ReactInfiniteScrollComponent, {
      children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, param) {
        const ogds = param[1];
        const term = param[0];
        const Key = "region_" + String(i);
        return JsxRuntime.jsxs("div", {
          children: [
            term === "" || Stdlib__List.length(ogds) === 0 ? null : JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("p", {
                  children: Buhta_landing__ClassifierModel.mapTerm(term),
                  className: "paragraph-medium text-black-landing"
                }),
                className: "px-4 bg-gray-pale rounded-md py-1 mt-4"
              }),
            Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, ogd) {
              const Key = String(i);
              const phone = ogd.contact_phone;
              return JsxRuntime.jsxs(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: /* Ru */ 1,
                  _2: {
                    TAG: /* Classifiers */ 8,
                    _0: {
                      TAG: /* Kogd */ 0,
                      _0: {
                        TAG: /* View */ 0,
                        _0: ogd.code
                      }
                    }
                  }
                },
                className: Cn.$plus(Cn.$plus("px-3 py-4 rounded-xl shadow-toast block toast-card", Cn.on("mt-0", ogd.code === "0101")), Cn.on("mt-2", ogd.code !== "0101")),
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("p", {
                        children: ogd.name,
                        className: "paragraph-small-medium text-black-landing"
                      }),
                      JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                        text: ogd.name
                      })
                    ],
                    className: "flex group justify-between"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                            children: "Код",
                            className: "caption text-gray-light-landing"
                          }),
                          JsxRuntime.jsx("p", {
                            children: ogd.code,
                            className: "paragraph-small text-gray-landing"
                          })
                        ]
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                            children: "БИН",
                            className: "caption text-gray-light-landing"
                          }),
                          JsxRuntime.jsx("p", {
                            children: ogd.tin,
                            className: "paragraph-small text-gray-landing"
                          })
                        ]
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                            children: "Телефон",
                            className: "caption text-gray-light-landing"
                          }),
                          JsxRuntime.jsx("p", {
                            children: phone !== undefined ? Formating.formatPhone(phone) : "-",
                            className: "paragraph-small text-gray-landing"
                          })
                        ]
                      })
                    ],
                    className: "flex gap-3 mt-3 justify-between"
                  })
                ],
                scrollToTop: false
              }, Key);
            }), ogds))
          ],
          className: ""
        }, Key);
      }), displayData)),
      next: loadMore,
      hasMore: match$1[0],
      dataLength: Buhta_landing__ClassifierModel.ogdLength(displayData),
      className: "contents",
      scrollableTarget: "ogdScrollWrapperMobile"
    }),
    className: "lg:hidden mt-4 overflow-auto",
    id: "ogdScrollWrapperMobile"
  });
}

const rows = 20;

const make = KogdListView;

export {
  rows,
  make,
}
/* Buhta_components__CopyButton Not a pure module */
